import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import Button from '@classify/react-core-components/Button';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
interface Props {
  prompt: string;
  buttonText: string;
  projectId?: number;
}
export default function CompanionLinkButton(t0) {
  const $ = _c(12);
  const {
    prompt,
    buttonText,
    projectId
  } = t0;
  const [canDisplayCompanion, setCanDisplayCompanion] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      const updateFromAttribute = () => {
        const attributeValue = document.body?.getAttribute("data-companion-permission");
        const isAllowed = attributeValue === "true";
        setCanDisplayCompanion(isAllowed);
      };
      updateFromAttribute();
      const observer = new MutationObserver(() => {
        updateFromAttribute();
      });
      if (document.body) {
        observer.observe(document.body, {
          attributes: true,
          attributeFilter: ["data-companion-permission"]
        });
      }
      return () => {
        observer.disconnect();
      };
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== projectId || $[3] !== prompt) {
    t3 = () => {
      const promptParameters = prompt === "tutoring" ? {
        project_id: projectId
      } : null;
      const companionEvent = new CustomEvent("openCompanion", {
        detail: {
          prompt,
          promptParameters,
          shouldOpenFullScreen: true
        }
      });
      window.dispatchEvent(companionEvent);
    };
    $[2] = projectId;
    $[3] = prompt;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClickToOpen = t3;
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FaceRetouchingNaturalIcon />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = !canDisplayCompanion;
  let t6;
  if ($[6] !== buttonText) {
    t6 = <span dangerouslySetInnerHTML={{
      __html: buttonText
    }} />;
    $[6] = buttonText;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== handleClickToOpen || $[9] !== t5 || $[10] !== t6) {
    t7 = <Button variant="secondary" onClick={handleClickToOpen} endIcon={t4} disabled={t5}>{t6}</Button>;
    $[8] = handleClickToOpen;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}